import assets from './assets'
import checkAccess from '../checkAccess'

const downloadFunction = async (endpoint: string): Promise<any> => {
  const url: string = assets.apiUrl + endpoint
  const access: string | undefined = await checkAccess()
  const headers: RequestInit = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${access}`
    }
  }

  try {
    const response: Response = await fetch(url, headers)
    if (response.status >= 200 && response.status <= 299) {
      return await response.blob()
    } else if (response.status === 404) {
      return false
    }
  } catch (e) {
    console.log(e)
  }
}

export default downloadFunction
